import { ShieldX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/utils/cn';
import { Button } from '@/components/ui/button';

interface AccessDeniedProps {
  className?: string;
}

export function AccessDenied({ className }: AccessDeniedProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 rounded-lg border border-destructive/20 bg-destructive/5 p-12 text-center',
        className
      )}
      role="alert"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
        <ShieldX className="h-6 w-6 text-destructive" />
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-semibold text-foreground">
          {t('auth.accessDenied.title')}
        </h3>
        <p className="max-w-md text-sm text-muted-foreground">
          {t('auth.accessDenied.description')}
        </p>
      </div>
      <Button variant="outline" onClick={() => navigate('/dashboard')}>
        {t('auth.accessDenied.backToDashboard')}
      </Button>
    </div>
  );
}
